// extracted by mini-css-extract-plugin
export default {"category":"TypesOfFiller_category__qSP7d","header":"TypesOfFiller_header__zhrt7","title":"TypesOfFiller_title__lxgUP"};